export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0024.4b9869cd.webp";